<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Customer announcements</h1>
    <div class="mb-6 flex justify-between items-center">
      <inertia-link class="btn-primary" :href="route('manage.announcements.create')">
        <span>Create</span>
        <span class="hidden md:inline">Annoucement</span>
      </inertia-link>
    </div>

    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Title</th>
          <th class="px-6 pt-6 pb-4">Period</th>
          <th class="px-6 pt-6 pb-4">Author</th>
        </tr>
        <tr v-for="row in announcements.data" :key="row.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4">
              {{ row.title }}
          </td>
          <td class="border-t px-6 py-4">
              {{ row.start_date | localDate }} {{ row.start_time }} <span v-if="row.start_date !== row.end_date"> to {{ row.end_date | localDate}} {{ row.end_time }}</span>
          </td>
          <td class="border-t px-6 py-4">
              {{ row.author.first_name }} {{ row.author.last_name }}
          </td>
          <td class="border-t px-6 py-4">
            <inertia-link v-if="canAdmin('update-announcements')" class="px-4 flex items-center" :href="route('manage.announcements.edit', row.id)" tabindex="-1">
              Edit <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="announcements.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No announcements found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="announcements.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  layout: Layout,
  components: {
    Icon,
    Pagination
  },

  props: {
    announcements: Object
  }
}
</script>
